import { render } from "./updateStatus.vue?vue&type=template&id=b0e45d0e&scoped=true"
import script from "./updateStatus.vue?vue&type=script&lang=js"
export * from "./updateStatus.vue?vue&type=script&lang=js"

import "./updateStatus.vue?vue&type=style&index=0&id=b0e45d0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e45d0e"]])

export default __exports__